import Module from '../module.js';
import {Reveal, Typography, Cursor} from '../../animations/index.js';
import Toggle from '../../toggle/toggle.js';

//css
import '../../../scss/components/_list.scss';
import './form.scss';

export class FormModule extends Module {

	constructor(el) {
		super(el);
	}

	init() {
    this.ready();
    this.reveal = new Reveal(this.node);
    Typography.split(this.node);
		this.typography = new Typography(this.node);
    this.cursor = Cursor.init(this.node);
    this.initToggle();
	}

  destroy() {
    Cursor.destroyAll();
    this.destroyed();
  }

  initToggle() {
    this.toggle = Toggle.init(
      '[data-form-btn]',
      '[data-form-target]',
      this.node,
      'active',
      this.onToggleForm.bind(this)
    );
    this.setFirstForm();
  }

  onToggleForm({ item }) {
    if (item.node.classList.contains('active')) {
      item.target.classList.add('active');
      item.node.toggleAttribute('aria-expanded');
      return;
    };
    this.resetFormButtons();
    this.setFormHeight(item);
    window.client.scroller.refresh();
  }

  setFirstForm() {
    const buttons = Array.from(this.node.querySelectorAll('[data-form-btn]'));
    buttons.forEach(item => item.style.opacity = 1);
  }

  setFormHeight(item) {
    const panel = item.target;
    item.node.classList.toggle('active');
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      this.resetMaxHeights();
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }

  resetFormButtons() {
    const buttons = Array.from(this.node.querySelectorAll('[data-form-btn]'));
    buttons.forEach(item => {
      item.classList.remove('active');
      item.style.opacity = 0.4;
    });
  }

  resetMaxHeights() {
    const panels = Array.from(this.node.querySelectorAll('[data-form-target]'));
    panels.forEach(panel => panel.style.maxHeight = null);
  }
}

export function createInstance() {
	const instance = new FormModule();
	return instance;
}
